export default __webpack_public_path__ + "static/media/mulher-970x1333.b606986a.jpg";